import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { navItems } from './navItems';
import './navbar.css'
NavBar.propTypes = {

};

function NavBar(props) {

    const [isShow, setIsShow] = useState(false)

    const showNav = () => setIsShow(!isShow);

    const [row1RAnimation, setRow1Animation] = useState('Row1AnimationOff')
    const [row3RAnimation, setRow3Animation] = useState('Row3AnimationOff')
    const [row2, setRow2] = useState('showRow')

    const iconAnimation = () => {
        row1RAnimation === 'Row1AnimationOff' ? setRow1Animation('Row1Animation') : setRow1Animation('Row1AnimationOff')
        row3RAnimation === 'Row3AnimationOff' ? setRow3Animation('Row3Animation') : setRow3Animation('Row3AnimationOff')
        row2 === 'showRow' ? setRow2('hideRow') : setRow2('showRow')

    }

    const initIdex = sessionStorage.getItem('index') || 0;
    const [isActive, setIsActive] = useState(initIdex)
    const checkLinkStatus = (index) => {
        setIsActive(index)
        sessionStorage.setItem('index', index)
    }



    return (
        <div className="Navbar">
            <div className="NavIcon" onClick={() => { showNav(); iconAnimation() }}>
                <div className={row1RAnimation}></div>
                <div className={row2}></div>
                <div className={row3RAnimation}></div>
            </div>
            <ul className={isShow ? 'Menu activeMenu' : 'Menu unActiveMenu'}>
                {navItems.map((item, index) => {
                    return (
                        <li className={item.className} key={index}  >
                            <Link onClick={() => { showNav(); iconAnimation(); checkLinkStatus(index) }} to={item.path} className={isActive == index ? "activeLink" : "inActiveLink"}>{item.title}</Link>
                        </li>
                    )
                })}
                <div className="cover-info">
                    <p className="address">Address: 143/14/23 Tân Mỹ, phường Tân Thuận Tây, quận 7</p>
                    <p className="contact-info">Tel: 0866905501 </p>
                    <p className="gmail">Gmail: dangphuocloc04082k@gmail.com</p>
                    <p className="  link">Facebook: <a onClick={() => window.open("https://www.facebook.com/kendi.dang", "_blank")}>Đặng Phước Lộc</a></p>
                </div>
            </ul>

        </div>
    );
}

export default NavBar;